import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { StepFunctions } from "../joyrideSteps";
import { useState } from "react";
import StartStep from "./StartStep";
import { useTranslation } from "react-i18next";

const ServicePerformer: React.FC<StepFunctions> = ({ goToStep }) => {
    const { t } = useTranslation();
    const [showStartStep, setShowStartStep] = useState(false);
    const handleButtonClick = () => setShowStartStep(true);
    return (
        <>
            {showStartStep ? (
                <StartStep setShowStartStep={setShowStartStep} />
            ) : (
                <Row>
                    <Col xs={11}>
                        <p className="fs-7">
                            <span className="fs-normal fw-bold fs-7">{t("Open the “Related employees”")}</span>{" "}
                            {t("on the service list page to select the service providers")}
                        </p>
                    </Col>
                    <Col xs={1} className="p-0 text-center">
                        <Button variant="link" className="p-0" onClick={handleButtonClick}>
                            <i className="bi bi-x-lg "></i>
                        </Button>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default ServicePerformer;
